const getStatusColor = status => {
  const statusColor = {
    Open: 'light-success',
    AwaitingOpen: 'light-info',
    Processing: 'light-info',
    EODComplete: 'light-success',
    AutomaticallyOpen: 'light-success',
    loanStatus: 'light-success',
    Yes: 'light-success',
    Active: 'light-success',
    Paid: 'light-success',
    Completed: 'light-success',
    InActive: 'light-secondary',
    Closed: 'light-secondary',
    Close: 'light-secondary',
    AwaitingEOD: 'light-secondary',
    AutomaticallyClosed: 'light-secondary',
    Inactive: 'light-secondary',
    No: 'light-secondary',
    Pending: 'light-pending',
    Enabled: 'light-success',
    Disabled: 'light-secondary',
    Expired: 'light-danger',
    Approved: 'light-success',
    Declined: 'light-danger',
    AwaitingNextReviewer: 'light-info',
    Canceled: 'light-secondary',
    ReworkRequired: 'light-secondary',
    Defaulting: 'light-pending',

    FullyPaid: 'light-success',
    PartiallyPaid: 'light-pending',
    NotYetDue: 'light-secondary',
    DueAndUnpaid: 'light-danger',
    EarlyTermination: 'light-success',

    AutoCleared: 'light-success',
    ManuallyCleared: 'light-success',
    Returned: 'light-danger',
    Uncleared: 'light-pending',

    Reversed: 'light-secondary',
    Failed: 'light-danger',
    Processed: 'light-success',
    PendingTSQ: 'light-pending',
    Successful: 'light-success',
    Issued: 'light-success',
    NotIssued: 'light-secondary',
    Linked: 'light-success',
    Unlinked: 'light-secondary',
    Generated: 'light-pending',
    Blocked: 'light-danger',
    Hotlisted: 'light-secondary',
    NEW: 'light-success',
    PENDING_PROCESSING: 'light-pending',
    CONFIRMED: 'light-success',
    AWAITING_SERVICE_PROVIDER: 'light-info',
    EXPIRED: 'light-danger',
    FAILED: 'light-danger',
    REVERSED: 'light-secondary',
    STAGED_FOR_REVERSAL: 'light-secondary',
    Submitted: 'light-success',
    Uploaded: 'light-success',
    Draft: 'light-pending',
    NoFileFound: 'light-pending',
  }
  return statusColor[status]
}

export default getStatusColor
